import { supabase } from '@/integrations/supabase/client';
import { userFacingErrorMessage, userFacingFailureText } from '@/utils/userFacingError';
import { translateOutsideReact } from '@/i18n/translateOutsideReact';

export interface UserOnboardingData {
  personalNumber: string;
  firstName: string;
  lastName: string;
}

export interface UserOnboardingResponse {
  success: boolean;
  error?: string;
}

export interface UserOnboardingStatusResponse {
  success: boolean;
  personalNumberCompleted: boolean;
  personalNumber?: string;
  isComplete: boolean;
  error?: string;
}

export const userOnboardingApiClient = {
  async getStatus(): Promise<UserOnboardingStatusResponse> {
    try {
      const { data: response, error } = await supabase.functions.invoke('user-onboarding-api', {
        body: { action: 'status' }
      });
      
      if (error) {
        return { 
          success: false, 
          personalNumberCompleted: false,
          isComplete: false,
          error: await userFacingFailureText(error, translateOutsideReact('consultantErrors.fallback.userOnboardingStatusLoad')) 
        };
      }
      
      return response;
    } catch (err) {
      return { 
        success: false, 
        personalNumberCompleted: false,
        isComplete: false,
        error: userFacingErrorMessage(err, translateOutsideReact('consultantErrors.fallback.userOnboardingStatusLoad')) 
      };
    }
  },

  async savePersonalNumber(personalNumber: string): Promise<UserOnboardingResponse> {
    try {
      const { data: response, error } = await supabase.functions.invoke('user-onboarding-api', {
        body: {
          action: 'save_personal_number',
          personalNumber
        }
      });

      if (error) {
        return { success: false, error: await userFacingFailureText(error, translateOutsideReact('consultantErrors.fallback.personalNumberSave')) };
      }

      return response;
    } catch (err) {
      return { 
        success: false, 
        error: userFacingErrorMessage(err, translateOutsideReact('consultantErrors.fallback.personalNumberSave')) 
      };
    }
  },

  async saveUserOnboardingData(data: UserOnboardingData): Promise<UserOnboardingResponse> {
    try {
      const { data: response, error } = await supabase.functions.invoke('user-onboarding-api', {
        body: {
          action: 'save_user_onboarding_data',
          ...data
        }
      });

      if (error) {
        return { success: false, error: await userFacingFailureText(error, translateOutsideReact('consultantErrors.fallback.detailsSave')) };
      }

      return response;
    } catch (err) {
      return { 
        success: false, 
        error: userFacingErrorMessage(err, translateOutsideReact('consultantErrors.fallback.detailsSave')) 
      };
    }
  }
};